// <head> metadata for VideosPage (https://www.dbos.dev/videos).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'DBOS Videos',
    },
    {
      name: 'description',
      content:
        'Explore the DBOS video library to learn more about open source durable execution and workflow orchestration for Python, TypeScript, Go, Java, and Kotlin backend development.',
    },
    {
      property: 'og:title',
      content: 'DBOS Videos',
    },
    {
      property: 'og:description',
      content:
        'Explore the DBOS video library to learn more about open source durable execution and workflow orchestration for Python, TypeScript, Go, Java, and Kotlin backend development.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'DBOS Videos',
    },
    {
      name: 'twitter:description',
      content:
        'Explore the DBOS video library to learn more about open source durable execution and workflow orchestration for Python, TypeScript, Go, Java, and Kotlin backend development.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/videos',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
